import "./svg/reusable-heart.svg"

// TODO replace heart and heart-clipped with this using positioning
// ORIGINAL COLOR: #C8102E
export default {
    name: "reusable-heart",
    viewBox: "51 50",
}
